import { createContext, useContext, useEffect, type FC, type ReactNode } from 'react'
import { type ChatbotExecutionStore } from 'widgets/ConversationMessages/ui/ConversationMessageFieldAlerts/ConversationChatbotAlert/store/ChatbotExecutionStore'

const ChatbotExecutionContext = createContext<ChatbotExecutionStore | null>(null)

export const useChatbotExecutionContext = () => {
  const store = useContext(ChatbotExecutionContext)

  if (store === null)
    throw new Error('You have forgotten to wrap your component with ChatbotExecutionProvider')

  return store
}

type IChatbotExecutionProviderProps = {
  store: ChatbotExecutionStore
  children: ReactNode
}

export const ChatbotExecutionProvider: FC<IChatbotExecutionProviderProps> = ({
  children,
  store,
}) => {
  useEffect(() => store.dispose, [])

  return (
    <ChatbotExecutionContext.Provider value={store}>{children}</ChatbotExecutionContext.Provider>
  )
}
